import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  type OnDestroy,
  type OnInit,
  type TemplateRef,
  ViewChild,
} from '@angular/core';

import { type Placement } from '@floating-ui/dom';
import { TourService } from '../tour.service';

@Component({
  selector: 'rcp-tour-step',
  template: `
    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>
  `,
  styleUrls: ['./tour-step.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TourStepComponent implements OnInit, OnDestroy {
  private tourService = inject(TourService);

  @Input() id: string;
  @Input() attachToElement: HTMLElement;
  @Input() position: Placement;
  @Input() sticky = false;

  // order in the tour if multiple items are on screen
  @Input() order: number;

  @ViewChild('contentTemplate')
  contentTemplate: TemplateRef<any>;

  ngOnInit() {
    // wait a tick for the contentTemplate to be projected
    setTimeout(() => {
      this.registerIfNotDismissed();
    });
  }

  ngOnDestroy() {
    this.tourService.unregisterTourStep(this.id);
  }

  private registerIfNotDismissed() {
    this.tourService.getTourItemWasDismissed(this.id).subscribe((wasDismissed) => {
      if (!wasDismissed) {
        this.tourService.registerTourStep({
          id: this.id,
          attachToElement: this.attachToElement,
          position: this.position,
          order: this.order,
          contentTemplate: this.contentTemplate,
          sticky: this.sticky,
        });
      }
    });
  }
}
